export default __webpack_public_path__ + "./fonts/magnifying-glass-svgrepo-com.22075a79.svg";